import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import RichMediaInfoTabCard from "../../../../V2/Cards/RichMedia/InfoTab"

import { storyblokLinkToYocoLink } from "@utils/storyblok"

const StoryblokRichMediaInfoTabCar = ({
  blok,
  mobileGridOrder,
  isSliderChild,
}: Storyblok.BlokProps<Storyblok.RichMediaInfoTabCard>) => {
  return (
    <RichMediaInfoTabCard
      mobileGridOrder={mobileGridOrder}
      backgroundVideo={
        storyblokLinkToYocoLink(blok.backgroundVideoUrl)?.url ?? ""
      }
      backgroundImage={blok.backgroundImage.filename}
      backgroundImageAlt={blok.backgroundImage.alt}
      accentColor={blok.accentColor}
      superscriptText={blok.superscriptText}
      titleText={blok.titleText}
      descriptionText={blok.descriptionText}
      buttonLink={storyblokLinkToYocoLink(blok.ctaLink) ?? ""}
      isSliderChild={isSliderChild}
      trackingEvent={blok.trackingEvent}
      trackingEventKey={blok.trackingEventKey}
      trackingEventValue={blok.trackingEventValue}
      autoplay={blok.autoplay}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokRichMediaInfoTabCar
